import React from "react"
import { FormSectionElements, FormSections, FormSubSections, LOVValues, ProgramContainer } from "../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import readXlsxFile from "read-excel-file";
import { Buffer } from 'buffer';
import LocalStorageService from "../services/SessionStorageService";
import { parseJson } from "../utilities/JsonUtils";
import { get } from "lodash";
import { getAppNameFromPath } from "../utilities/URLUtils";
import * as xml2js from 'xml2js';
interface Props {
    programContainer: ProgramContainer;
    callback: (programContainer: ProgramContainer)=> void;

}

interface State {
    uploadError: string | null;
}

export class UploadComponent extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            uploadError: null
        };
    }


    upload = () => {

        let htmlString = [];

        if (this.state.uploadError) {
            htmlString.push(
                <div key="uploadError" style={{
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    padding: '12px',
                    borderRadius: '4px',
                    border: '1px solid #f5c6cb',
                    marginBottom: '16px'
                }}>
                    <strong>Upload Error:</strong> {this.state.uploadError}
                </div>
            );
        }

        htmlString.push(<div key="fileUpload"> { }
            {/* @ts-ignore */}
            <FileUpload name="attachment[]" customUpload={true} maxFileSize={500000000} onRemove={this.fileUploader} auto={true} uploadHandler={this.fileUploader} multiple={false} />
        </div>);

        return htmlString;
    }


    fileUploader = (e) => {
        let attachment = {};

        e.files.forEach(element => {
            var reader = new FileReader();
            reader.onload = () => {
                attachment["attachmentFileName"] = element.name;
                attachment['attachmentFileType'] = element.type;
                attachment['attachmentFileContent'] = reader.result;
                switch (element.type) {
                    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                        this.generateFormSection(element);
                        break;
                    case 'application/json':
                        const base64String = attachment['attachmentFileContent'].replace('data:application/json;base64,', '');
                        const decodedString = Buffer.from(base64String, 'base64').toString('utf8');
                        const formSection = parseJson(decodedString, getAppNameFromPath());
                        const currentForm = this.props.programContainer;
                        if (!currentForm.id || currentForm.CategoryId != formSection.CategoryId) {
                            formSection.createdById = LocalStorageService.getUserId();
                            formSection.id = null;
                            formSection.Creator = null;
                        } else {
                            formSection.id = currentForm.id;
                            formSection.createdById = currentForm.createdById ?? currentForm.createdBy;
                            formSection.Creator = currentForm.Creator;
                            formSection.Coowners = currentForm.Coowners;
                        }
                        this.props.callback(formSection);
                        break;
                    case 'text/xml':
                    case 'application/xml':
                        this.handleXMLUpload(attachment);
                        break;
                }
            }

            reader.readAsDataURL(element);

        });

    };

    validateXMLWellFormed = async (xmlContent: string): Promise<{ valid: boolean; error?: string }> => {
        try {
            const parser = new xml2js.Parser({ strict: true });
            await parser.parseStringPromise(xmlContent);
            return { valid: true };
        } catch (error) {
            return { valid: false, error: `XML is not well-formed: ${error.message}` };
        }
    };

    validateXMLAttachments = (xmlContent: string): { valid: boolean; error?: string } => {
        const maxAttachmentSize = 20 * 1024 * 1024; // 20MB in bytes

        // Regular expression to find base64 encoded attachments
        // This looks for common base64 patterns that might represent attachments
        const base64Pattern = /<[^>]*>([A-Za-z0-9+/]{100,}={0,2})<\/[^>]*>/g;
        let match;

        while ((match = base64Pattern.exec(xmlContent)) !== null) {
            const base64Content = match[1];

            // Calculate the approximate size of the decoded content
            // Base64 encoding increases size by ~33%, so decoded size = encoded length * 0.75
            const decodedSize = (base64Content.length * 3) / 4;

            // Adjust for padding
            const padding = (base64Content.match(/=/g) || []).length;
            const actualSize = decodedSize - padding;

            if (actualSize > maxAttachmentSize) {
                return {
                    valid: false,
                    error: `XML contains an attachment larger than 20MB (approximately ${(actualSize / (1024 * 1024)).toFixed(2)}MB)`
                };
            }
        }

        return { valid: true };
    };

    handleXMLUpload = async (attachment: any) => {
        try {
            // Decode base64 content to get the XML string
            const base64String = attachment['attachmentFileContent'].replace(/^data:.*?;base64,/, '');
            const xmlContent = Buffer.from(base64String, 'base64').toString('utf8');

            // Validate XML is well-formed
            const wellFormedResult = await this.validateXMLWellFormed(xmlContent);
            if (!wellFormedResult.valid) {
                this.setState({ uploadError: wellFormedResult.error });
                console.error(wellFormedResult.error);
                throw new Error(wellFormedResult.error);
            }

            // Validate attachment sizes
            const attachmentResult = this.validateXMLAttachments(xmlContent);
            if (!attachmentResult.valid) {
                this.setState({ uploadError: attachmentResult.error });
                console.error(attachmentResult.error);
                throw new Error(attachmentResult.error);
            }

            // If validation passes, parse and process the XML
            const parser = new xml2js.Parser({ explicitArray: false, mergeAttrs: true });
            const result = await parser.parseStringPromise(xmlContent);

            console.log('XML validation passed successfully');
            console.log('Parsed XML:', result);

            // Clear any previous errors
            this.setState({ uploadError: null });

            // TODO: Add your XML processing logic here
            // For now, just log success
            console.log('XML file uploaded and validated successfully!');

        } catch (error) {
            const errorMessage = `Failed to process XML file: ${error.message}`;
            this.setState({ uploadError: errorMessage });
            console.error(errorMessage, error);
            throw error;
        }
    };

    generateFormSection = (file) => {
        let programContainer = new ProgramContainer();

        programContainer.ListOfFormSections = new Array<FormSections>();
        programContainer.Name = file.name;

        readXlsxFile(file).then((rows) => {

            let section: FormSections;
            let subSection: FormSubSections;
            let isTableSubsection = false;
            let tableSub;
            rows.forEach((row, index) => {
                if (row[0] != null && (row[0].toString() == 'Section' || row[0].toString().indexOf('Instructions') > -1)) {
                    return;
                }

                //section
                if (row[0] != null) {

                    isTableSubsection = false
                    section = new FormSections();
                    section.parent=programContainer;
                    section.ENUTitle = row[0] ? row[0].toString() : null;
                    section.ENUDescription = row[1] ? row[1].toString() : null;
                    section.Sequence = programContainer.ListOfFormSections.length + 1;
                    section.Id = section.Sequence.toString();
                    programContainer.ListOfFormSections.push(section);

                    //if on the section level, such as Adress section, it is a table
                    let dataType = row[14] != null && row[14].toString().replace(/\s/g, '');
                    if (dataType == 'Table') {
                        section.ListOfFormSubSections = [];
                        let ele = new FormSectionElements();
                        ele.ENUTitle = row[0]?.toString();
                        ele.LoadBindName = ele.ENUTitle?.toString().replace(/\s/g, '');
                        ele.Datatype = 'Table';
                        subSection = new FormSubSections();
                        subSection.parent = section;
                        subSection.ListOfFormSectionElements = [];
                        subSection.ListOfFormSectionElements.push(ele);
                        section.ListOfFormSubSections.push(subSection)
                        ele.Sequence = 1;
                        ele.parent = subSection;
                        tableSub = new FormSubSections();
                        tableSub.parent = ele;
                        if (ele.subSectionList == null) {
                            ele.subSectionList = [];
                        }
                        ele.Editable = "Y";
                        ele.subSectionList.push(tableSub);
                        isTableSubsection = true;
                    }
                }

                //if there is no sub section for section or multiple subsections
                if ((row[2] == null && row[0] !== null) || (row[2] !== null && row[0] == null && index + 1 < rows.length && rows[index + 1][2] != null && section.ListOfFormSubSections == null)) {
                    let dataType = row[14] != null && row[14].toString().replace(/\s/g, '');
                    if (dataType !== 'Table') {
                        subSection = new FormSubSections();
                        subSection.Sequence = section.ListOfFormSubSections != null ? section.ListOfFormSubSections.length + 1 : 1;
                        subSection.Id = subSection.Sequence.toString();
                        subSection.parent = section;
                        subSection.ENUTitle = row[2] ? row[2].toString() == 'N/A' ? null : row[2].toString() : null;
                        if (section.ListOfFormSubSections == null)
                            section.ListOfFormSubSections = [];
                        section.ListOfFormSubSections.push(subSection);
                    }
                }

                //if sub section is a table
                if (row[2] != null) {
                    let dataType = row[14] != null ? row[14].toString().replace(/\s/g, '') : null;

                    //if the sub section is a table, add an element additonally then create a table
                    if (dataType == 'Table') {
                        let ele = new FormSectionElements();
                        ele.ENUTitle = row[2]?.toString();
                        ele.LoadBindName = ele.ENUTitle?.toString().replace(/\s/g, '');
                        ele.Datatype = 'Table';
                        subSection.ListOfFormSectionElements.push(ele);
                        ele.Sequence = subSection.ListOfFormSectionElements.length + 1;
                        ele.parent = subSection;

                        tableSub = new FormSubSections();
                        tableSub.parent = ele;
                        if (ele.subSectionList == null) {
                            ele.subSectionList = [];
                        }
                        ele.Editable = "Y";
                        ele.subSectionList.push(tableSub);
                        isTableSubsection = true;
                    }
                }
                if (row[7] !== null) {
                    let ele = new FormSectionElements();
                    ele.ENUTitle = row[13]?.toString();
                    ele.LoadBindName = row[5] != null ? row[5].toString() : ele.ENUTitle?.toString().replace(/\s/g, '');
                    ele.Datatype = row[14].toString().replace(/\s/g, '');;
                    ele.Length = row[15] ? row[15].toString() : '255';
                    ele.Editable = row[16] ? (row[16].toString() == 'Y' ? 'N' : 'Y') : 'Y';
                    ele.Optional = row[17] ? (row[17].toString() == 'Y' ? 'Y' : 'N') : 'Y';

                    if (ele.Datatype === 'MultiText') {
                        ele.counterVisible = true;
                    }
                    if (ele.Datatype == 'Dropdown') {
                        ele.ListOfLOVValues = this.readLov(row[18]);
                    }

                    if (isTableSubsection == false) {
                        ele.Sequence = subSection.ListOfFormSectionElements.length + 1;
                        ele.parent = subSection;
                        subSection.ListOfFormSectionElements.push(ele);
                    } else {
                        ele.Datatype = row[14].toString().replace(/\s/g, '');;
                        ele.Sequence = tableSub.ListOfFormSectionElements.length + 1;
                        ele.parent = tableSub;
                        tableSub.ListOfFormSectionElements.push(ele);
                   }
                }

            });
        })
        programContainer.displayForm='panel';
        this.props.callback(programContainer)
    }

    //read LOV from excel file
    readLov = (col) => {
        if (col != null) {
            return col.split(/\r?\n/).map(p => {
                let lov = new LOVValues();
                lov.parent=p;
                lov.code = p;
                lov.description = p;
                return lov;
            });
        }
        return [];
    }


    render() {
        return (
            this.upload()
        )
    }
}
